export default "__VITE_ASSET__2mAIRQaV__"